<h1 cds-text="title">Operation Approvals</h1>
<h2 cds-text="section">Pending Approvals</h2>
<app-pending-approvals-datagrid></app-pending-approvals-datagrid>

<h2 cds-text="section">Closed Approvals</h2>
<app-closed-approvals-datagrid></app-closed-approvals-datagrid>
